import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-provider-logins',
  templateUrl: './provider-logins.component.html',
  styleUrl: './provider-logins.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ProviderLoginsComponent {}
